<template>
  <!-- 延遲訂單 -->
  <cus-dialog-in-dialog>
    <template v-slot:body>
      <div>
        <div class="take-time">
          <p>原取餐時間</p>
          <p>{{ cusProps.order_take_time.split(' ')[1] }}</p>
        </div>
        <div class="delay-time">
          <p>延遲時間</p>
          <p @click="showDropdown = !showDropdown">
            延遲 {{ delay_minute.label }}
            <i class="bi bi-caret-down-fill" style="margin-left: 8px"></i>
          </p>
          <div v-if="showDropdown" class="drop-down-menu">
            <ul class="menu-list">
              <li
                v-for="(item, index) in dropdownList"
                :key="index"
                :class="delay_minute.value === item.value ? 'select' : ''"
                @click="handleClick(item)"
              >
                {{ item.label }}
              </li>
            </ul>
          </div>
        </div>
        <div style="padding: 0 4px">
          <cus-radio-column
            :radioList="radioList"
            v-model:selectValue="select_reason"
            v-model:input_reason="input_reason"
          ></cus-radio-column>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button text="取消" color="white" :width="50" @click="close"></cus-button>
        <cus-button
          text="確定"
          color="blue"
          :width="50"
          :disabled="!select_reason || (select_reason === 'other' && !input_reason)"
          @click="submit({ delay_minute, input_reason, select_reason })"
        ></cus-button>
      </div>
    </template>
  </cus-dialog-in-dialog>
</template>
<script>
import { inject, ref, reactive } from 'vue';
import { useGetters, useActions } from '@/utils/mapStore';

export default {
  name: 'delay-order',
  setup() {
    // const { proxy } = getCurrentInstance();
    //接受provide值
    const { cusProps } = inject('inner_cusProps');
    const close = inject('inner_close');
    const submit = inject('inner_submit');

    //建立清單
    const dropdownList = reactive([
      { label: '15 分鐘', value: 15 },
      { label: '30 分鐘', value: 30 },
      { label: '45 分鐘', value: 45 },
      { label: '1 小時', value: 60 },
    ]);
    const radioList = reactive([]);
    const getReasonList = useGetters('handleOrder', ['getReasonList']);
    const doReasonList = useActions('handleOrder', ['doReasonList']);
    const list = async () => {
      await doReasonList();
      getReasonList.value.order_delay_reason.forEach((reason) => {
        radioList.push({ label: reason, value: reason });
      });
    };
    list();

    //建立參數
    const delay_minute = ref(dropdownList[0]);
    const input_reason = ref('');
    const select_reason = ref(null);
    const showDropdown = ref(false);

    //下拉式選單
    const handleClick = (val) => {
      delay_minute.value = val;
      showDropdown.value = false;
    };
    return {
      close,
      submit,
      cusProps,
      dropdownList,
      radioList,
      delay_minute,
      input_reason,
      select_reason,
      showDropdown,
      handleClick,
    };
  },
};
</script>
<style lang="scss" scoped>
.take-time {
  @include flex-between-center;
  padding: 10px 20px;
  p:nth-of-type(1) {
    color: $color-gray-60;
    font-size: 2rem;
  }
  p:nth-of-type(2) {
    color: $color-blue;
    font-size: 2.2rem;
  }
}
.delay-time {
  background-color: $color-gray-3;
  border: 2px solid $color-gray-10;
  border-radius: 4px;
  @include flex-between-center;
  padding: 10px 16px;
  margin: 10px 4px 20px;
  position: relative;
  p:nth-of-type(1) {
    color: $color-gray-60;
    font-size: 2rem;
  }
  p:nth-of-type(2) {
    color: $color-blue;
    font-size: 2.2rem;
    cursor: pointer;
  }
  .drop-down-menu {
    position: absolute;
    width: 60%;
    background-color: #fff;
    border: 2px solid $color-gray-10;
    border-radius: 4px;
    top: calc(100% + 5px);
    right: -2px;
    z-index: 10;
    @include flex-center-center;
    ul {
      width: 100%;
      font-size: 2rem;
      color: $color-blue;
      text-align: center;
      li {
        padding: 8px 0;
        border-bottom: 2px dashed $color-gray-10;
      }
      li:last-child {
        border: none;
      }
      .select {
        background-color: $color-green;
        color: #fff;
        border-bottom: 2px solid $color-green;
      }
    }
  }
}
</style>
